<template>
  <div class="live-box" ref="livebox">
    <headerBlack-view></headerBlack-view>
        <el-breadcrumb separator="/" class="bread-crumb main">
            <el-breadcrumb-item :to="{ path: '/news' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: `${breadcrumb.path}` }">{{breadcrumb.name}}</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: `/yunqiao/subject/detail/${$route.query.activeId}` }">课程详情</el-breadcrumb-item>
            <el-breadcrumb-item>{{courseName?courseName:''}}</el-breadcrumb-item>
        </el-breadcrumb>
    <div style="" class="video-container flex-layout">
      <div class="video-wrapper" >
        <video :controls='controlVisible' id="video" :src="videoSrc" controlsList="nodownload" autoplay  v-if="controlVisible">
          您的浏览器不支持 video 标签。
        </video>
        <p class="tips" v-if="tipsVisible">
          试看5分钟，查看完整版课程请 
          <span @click="toPlatform">登录 </span> 
          <em class="el-icon-close" @click="tipsVisible = false"></em> 
        </p>
        <div class="cover" v-if="coverVisible"></div>
      </div>
      <div class="video-sidebar">
        <div class="group time">
          <h3>课节时间</h3>
          <p>{{courseTime}}</p>
        </div>
        <div class="group introduction">
          <h3>课程介绍</h3>
          <p>{{courseInfo.courseExplain}}</p>
        </div>
      </div>
    </div>
    <footer-view></footer-view>
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%" 
      top="40vh"
      center
      :modal="false">
      <strong class="f18 tc" style="display:block;">完整版视频需登录观看</strong>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="toPlatform">登录</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  export default {
    data() {
      return {
        videoSrc: '', //视频地址
        info: {}, //课节信息
        courseInfo: { //课节所在在课程信息
          assistantInfo: {
            introduce: ''
          }
        },
        timer: '', //计时器
        count: 0, //计数
        lessonId: 0,
        baseURL:'https://ws_test.cnuen.net/api/open/file/getByIdentifier?identifier=', //头像等拼接地址
        proId:0,
        dialogVisible: false, //弹窗
        tipsVisible:false, //提示语
        coverVisible:false, //黑色遮罩层
        controlVisible:true, //视频控制器
        courseTime:'',
        courseName:'',
        
      };
    },
    computed: {
      breadcrumb() {
        this.proId = sessionStorage.getItem('projectID')
            let map = {
                90 : {
                    name:'首师智研',
                    path:'/yunqiao/wisdom'
                },
                109 : {
                    name:'1+X后勤管理与职业教育系统',
                    path:'/yunqiao/logistics'
                },
                110 : {
                    name:'内蒙古自治区三科统编教材中部四盟市教师专项培训',
                    path:'/yunqiao/innerMongolia'
                }
            }
            return map[this.proId] ? map[this.proId] : {name:'',path:''}
        }
    },
    methods: {
      async getLiveUrl() {
        let id = this.$route.query.id;
        // 获取课节信息
        let resData = await this.$Api.Course.getAsnycLive(id);
        // 获取课节视频地址
        let resDatas = await this.$Api.Course.getLessonVideoUrl(id);
        this.info = resData.data;
        this.videoSrc = `${this.downloadURL}${resDatas.data}`
        console.log(this.videoSrc)
        console.log(this.info)
        //禁用静音
        let _video = document.getElementById("video");
        setTimeout(() => {
          _video.muted = false;
        }, 100)

        //通过课程id查询课程信息
        let courseId = resData.data.courseProjectId
        console.log(courseId)
        this.getCourseInfo(courseId)

      },
      //获取课程信息
       async getCourseInfo() {
            let resData = await Api.Wisdom.getCourseInfo(this.$route.query.activeId);
             console.log(resData);
            if(!resData.data) return
            this.courseInfo = resData.data;
            this.courseName = resData.data.latestLesson.name
            this.time();
        },
      //监听视频时间并操作
      getVideoInfo() {
        let _video = document.getElementById('video')

        //监听视频播放时间 (勿删)
        _video.addEventListener('timeupdate', () => {
          let _currentTimeCeil = Math.ceil(_video.currentTime)
          let _currentTimeFloor = Math.floor(_video.currentTime)
          //分别向上、向下取整时间，保证题目出现视频播放在同一时间
          if (_currentTimeFloor >= 300) {
            this.tipsVisible = true;
            this.coverVisible = true;
            this.dialogVisible = true;
            this.controlVisible = false;
            _video.currentTime = 0;
            _video.pause();
          }
          if (_currentTimeCeil >= 300.1 && this.isPause) { //给一个isPause否则视频会因为时间未过6秒而被暂停
            _video.pause();
          }

         
        })
        // 监听视频播放
        _video.addEventListener('play', () => {
           console.log('play')
        })

        // 监听视频暂停
        _video.addEventListener('pause', () => {
          console.log('pause')
        })

        // 监听视频结束
        _video.addEventListener('ended', () => {
          console.log('ended')
        })

        _video.oncontextmenu = ()=>{
           return false;
        }


      },
      // 处理课节时间
      time() {
        let begin = this.courseInfo.latestLesson.lessonsBeginTime ? this.dayjs(this.courseInfo.latestLesson.lessonsBeginTime*1000).format('YYYY-MM-DD HH:mm') : ''
        let end = this.courseInfo.latestLesson.lessonsEndTime ? tthis.dayjs(this.courseInfo.latestLesson.lessonsEndTime*1000).format('YYYY-MM-DD HH:mm') : ''
        if(end) {
          this.courseTime =  `${begin}-${end}`
        } else {
          this.courseTime = `${begin}`
        } 
        // return sessionStorage.getItem('videoTime');
      },
      toPlatform() {
        window.open('https://yun.cnuen.net/login')
      },
      // 页面初始化
      init() {
          this.lessonId = this.$route.query.id
          this.getLiveUrl();
      }
    },
    mounted() {
      this.getVideoInfo();
      this.getCourseInfo();
      this.videoSrc = this.downloadURL + sessionStorage.getItem('videoUrl');
    },
  };
</script>

<style lang="less" scoped>
  .live-box {
    position: absolute;
    width: 100%;
    height: 100%;
    padding: 0;
  }

  .bread-crumb {
    margin: 20px 35px;
  }

  .video-container {
    height: calc(100% - 144px);
  }

  .video-wrapper {
    position: relative;
    width: 90%;

    video {
      width: 100%;
      height: 100%;
      // max-width: 1300px;
      background-color: #000;
    }

    .cover {
      width: 100%;
      height: 100%;
      // max-width: 1300px;
      background-color: #000;
      position: absolute;
      z-index: 9;
    }
    

    .tips {
      -webkit-user-select: none;
      -moz-user-select: none;
      position: absolute;
      bottom: 25px;
      left: 20px;
      font-size: 18px;
      color: #fff;
      z-index: 999;
      span {
        color: #1474EB;
        cursor: pointer;
      }
      .el-icon-close {
        vertical-align: middle;
        cursor: pointer;
      }
    }
  }

  .title {
    text-align: center;
    height: 2%;
  }

  .video-sidebar {
    padding: 0 20px;
    width: 20%;
    background-color: #282933;

    .group {
      margin-top: 20px;

      &:first-child {
        margin-top: 15px;
      }
    }


    h3 {
      line-height: 36px;
      color: #fff;
      font-size: 16px;
      font-weight: 500;

      &::before {
        content: ' ';
        display: inline-block;
        border-radius: 25%;
        width: 4px;
        height: 20px;
        background-color: #218AB8;
        margin-right: 10px;
        margin-bottom: -5px;
      }
    }

    p {
      color: #fff;
      padding: 0 15px;
    }

    .list /deep/.el-button--primary {
      margin: 20px 15px 0;
      color: #218AB8;
      background-color: transparent;
      border-color: #218AB8;
      padding: 12px 18px;
    }


    .time p {
      font-size: 14px;
      margin: 5px 0 20px;
    }

    .problem {
      .options {
        margin-bottom: 25px;

        /deep/.el-radio {
          display: block;
          margin: 10px 25px;
          color: #fff;
        }
      }

      /deep/.el-button--primary {
        width: 70%;
        display: block;
        margin: 0 auto;
      }

      /deep/.el-button--primary.is-plain {
        color: #fff;
        border-color: #409EFF;
        background-color: #409EFF;

        &:hover {
          background-color: #66b1ff;
          border-color: #66b1ff;
        }
      }
    }

  }


  iframe {
    margin: 0;
    padding: 0;
  }
</style>